import React, { useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { LegalModal } from '../components/LegalModal';
type ModalType = 'terminos' | 'privacidad' | null;
export function SalesPage() {
  const [modal, setModal] = useState<ModalType>(null);
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-249">
      <HeroSection data-id="element-250" />
      <ProblemSection data-id="element-251" />
      <SolutionSection data-id="element-252" />
      <WhatInsideSection data-id="element-253" />
      <TestimonialsSection data-id="element-254" />
      <PricingSection data-id="element-255" />
      <GuaranteeSection data-id="element-256" />
      <FinalCTASection data-id="element-257" />

      <footer className="bg-[#2C1810] text-[#FDF6EC] py-8 text-center text-sm" data-id="element-258">
        <div className="max-w-7xl mx-auto px-4" data-id="element-259">
          <p className="text-gray-400" data-id="element-260">
            © 2026 Cena de 7 Minutos. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 mt-4" data-id="element-261">
            <button onClick={() => setModal('terminos')} className="text-gray-400 hover:text-[#F5A623] transition underline underline-offset-2" data-id="element-262">
              Términos y Condiciones
            </button>
            <button onClick={() => setModal('privacidad')} className="text-gray-400 hover:text-[#F5A623] transition underline underline-offset-2" data-id="element-263">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      <LegalModal type={modal} onClose={() => setModal(null)} data-id="element-264" />
    </main>;
}